export const NchcrRequiredFieldsMessage = (multiple) => (
    <>
        {multiple ? <p>One or more candidates is missing fields required for NCHCR. Below are the required fields.</p> : <p>This candidate is missing one or more of the following fields.</p>}
        <ul>
            <li>First Name</li>
            <li>In-House ID</li>
            <li>State</li>
            <li>Visa Type</li>
            <li>Job Type(s)</li>
            <li>Board Certified (if Physician)</li>
            <li>Preferred States to Work</li>
        </ul>
    </>
);

export const NchcrRequiredJobFieldsMessage = (multiple) => (
    <>
        {multiple ? <p>One or more jobs is missing fields required for NCHCR. Below are the required fields.</p> : <p>This job is missing one or more of the following fields.</p>}
        <ul>
            <li>Specialty / Sub-Specialty</li>
            <li>Accept New Grads</li>
            <li>State</li>
            <li>Job Type</li>
            <li>Job Description</li>
            <li>Visa Type</li>
            <li>Open To Splits</li>
        </ul>
    </>
);